module.exports = __webpack_public_path__ + "img/flashMob.f1a70ab6.jpg";